// import {APP_URL} from '../../../../../../resources/assets/js/config';
const APP_URL = process.env.MIX_APP_URL;
/**
 *
 * @param {string} api_route_uri
 * @property params.params.sale
 * @property params.params
 * @property params.route
 * @namespace params       contains the route and any parameters to add to the route
 * @param params
 * @param {function} callback - the response of the result
 */
export function route(api_route_uri, params, callback) {
	axios.post(api_route_uri, params)
		.then(function (response) {
			return callback(response.data);
			// return response.data;
		})
		.catch(function (error) {
			console.error(error);
		});
}

// let example = {
// 	route: this.sale_route_name,
// 	params: {
// 		sale: list.id
// 	}
// };
export function getRoute(api_route_uri, params) {
	return axios.post(api_route_uri, params)
		.then(function (response) {
			// return  callback(response.data);
			// console.log('response.data',response.data);
			return response.data;
		})
		.catch(function (error) {
			console.error(error);
		});
}

export function createUrlFromUrlAndParams(url, params) {
	let urlFormatted = url.replace(/\/+$/, "");

	return `${urlFormatted}/${params}`;
}

/**
 * creates url from the pattern and matching the keys by the params supplied
 * @param {string} uri_pattern
 * @param {object} params
 * @param uri
 */
export function getUrl(uri_pattern, params, uri) {

	let result = replaceKeysWithParams(uri_pattern, getParamKeys(uri_pattern), params);
	if (typeof uri !== 'undefined' && uri !== null) {
		return '/' + result;
	}
	// console.log('getUrl', 'uri_pattern',uri_pattern, 'params',params);
	//
	// if (APP_URL[APP_URL.length - 1] == '/') {
	// 	return APP_URL + result;
	// }
	return '/' + result;
}

/**
 *
 * @param {string} uri_pattern
 * @param {array} keys
 * @param {object} params
 * @returns {string}
 */
export function replaceKeysWithParams(uri_pattern, keys, params) {
	let uri = uri_pattern;
	// loop keys to replace in string
	for (let i = 0; i < keys.length; i++) {
		let key = keys[i];

		/**
		 * replace each reference in the string with the key wrapped in the curly braces
		 */
		if (key in params) {
			uri = uri.replace('{' + key + '}', params[key]);
		}

	}
	// console.log('replaceKeysWithParams', 'uri',uri);
	return uri;
}

/**
 * Gets the keys wrapped in curly braces e.g. /my_test/{id}/{another}
 *
 * @param {string} pattern
 * @returns {*} [id,another]
 */
function getParamKeys(pattern) {
	return pattern.match(/[^{\}]+(?=})/g)
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/routes.js